import React from 'react';
import classNames from 'classnames';

import styles from './CircularProgress.module.scss';

interface CircularProgressProps {
  height?: number;
  width?: number;
  centered?: boolean;
  className?: string;
}

const CircularProgress = ({ width = 80, height = 80, centered, className }: CircularProgressProps) => (
  <div
    className={classNames(styles.circular_progress, className, { [styles.centered]: centered })}
    style={{ width, height }}
  />
);

export default CircularProgress;
